module.exports = __webpack_public_path__ + "img/Game_49220.05ad8599.png";